import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _06d5b676 = () => interopDefault(import('../pages/activity/index.vue' /* webpackChunkName: "pages/activity/index" */))
const _946ffa22 = () => interopDefault(import('../pages/ceshi.vue' /* webpackChunkName: "pages/ceshi" */))
const _34665f29 = () => interopDefault(import('../pages/clean_cache.vue' /* webpackChunkName: "pages/clean_cache" */))
const _822d42ae = () => interopDefault(import('../pages/plugin/index.vue' /* webpackChunkName: "pages/plugin/index" */))
const _4532f244 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _3e26548e = () => interopDefault(import('../pages/404/activity.vue' /* webpackChunkName: "pages/404/activity" */))
const _0e84ade8 = () => interopDefault(import('../pages/404/activity-res.vue' /* webpackChunkName: "pages/404/activity-res" */))
const _1b585c5d = () => interopDefault(import('../pages/404/plugin.vue' /* webpackChunkName: "pages/404/plugin" */))
const _68ee0f38 = () => interopDefault(import('../pages/404/resource.vue' /* webpackChunkName: "pages/404/resource" */))
const _2e62836e = () => interopDefault(import('../pages/activity/detail.vue' /* webpackChunkName: "pages/activity/detail" */))
const _284fdb6b = () => interopDefault(import('../pages/activity/resource.vue' /* webpackChunkName: "pages/activity/resource" */))
const _4e3ca3ea = () => interopDefault(import('../pages/plugin/activity/index.vue' /* webpackChunkName: "pages/plugin/activity/index" */))
const _48b1ba30 = () => interopDefault(import('../pages/plugin/activity/detail.vue' /* webpackChunkName: "pages/plugin/activity/detail" */))
const _3b77d586 = () => interopDefault(import('../pages/media/profile/_id.vue' /* webpackChunkName: "pages/media/profile/_id" */))
const _084accf7 = () => interopDefault(import('../pages/media/resource/_id.vue' /* webpackChunkName: "pages/media/resource/_id" */))
const _393e115e = () => interopDefault(import('../pages/plugin/_id.vue' /* webpackChunkName: "pages/plugin/_id" */))
const _13332971 = () => interopDefault(import('../pages/profile/_id.vue' /* webpackChunkName: "pages/profile/_id" */))
const _27f9f66c = () => interopDefault(import('../pages/resource/_id.vue' /* webpackChunkName: "pages/resource/_id" */))
const _3cd303d2 = () => interopDefault(import('../pages/tag/_tag_name.vue' /* webpackChunkName: "pages/tag/_tag_name" */))
const _8ef6e2a2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/community/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activity",
    component: _06d5b676,
    name: "activity"
  }, {
    path: "/ceshi",
    component: _946ffa22,
    name: "ceshi"
  }, {
    path: "/clean_cache",
    component: _34665f29,
    name: "clean_cache"
  }, {
    path: "/plugin",
    component: _822d42ae,
    name: "plugin"
  }, {
    path: "/search",
    component: _4532f244,
    name: "search"
  }, {
    path: "/404/activity",
    component: _3e26548e,
    name: "404-activity"
  }, {
    path: "/404/activity-res",
    component: _0e84ade8,
    name: "404-activity-res"
  }, {
    path: "/404/plugin",
    component: _1b585c5d,
    name: "404-plugin"
  }, {
    path: "/404/resource",
    component: _68ee0f38,
    name: "404-resource"
  }, {
    path: "/activity/detail",
    component: _2e62836e,
    name: "activity-detail"
  }, {
    path: "/activity/resource",
    component: _284fdb6b,
    name: "activity-resource"
  }, {
    path: "/plugin/activity",
    component: _4e3ca3ea,
    name: "plugin-activity"
  }, {
    path: "/plugin/activity/detail",
    component: _48b1ba30,
    name: "plugin-activity-detail"
  }, {
    path: "/media/profile/:id?",
    component: _3b77d586,
    name: "media-profile-id"
  }, {
    path: "/media/resource/:id?",
    component: _084accf7,
    name: "media-resource-id"
  }, {
    path: "/plugin/:id",
    component: _393e115e,
    name: "plugin-id"
  }, {
    path: "/profile/:id?",
    component: _13332971,
    name: "profile-id"
  }, {
    path: "/resource/:id?",
    component: _27f9f66c,
    name: "resource-id"
  }, {
    path: "/tag/:tag_name?",
    component: _3cd303d2,
    name: "tag-tag_name"
  }, {
    path: "/",
    component: _8ef6e2a2,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
